import script from "./referral.vue?vue&type=script&setup=true&lang=js"
export * from "./referral.vue?vue&type=script&setup=true&lang=js"

import "./referral.vue?vue&type=style&index=0&id=a5fba58c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5fba58c"]])

export default __exports__